import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "pay-subscription-modal-icon-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "loading-screen"
}
const _hoisted_6 = {
  key: 0,
  class: "payment-info"
}
const _hoisted_7 = { class: "payment-info-error" }
const _hoisted_8 = { class: "order-submission-error-message error" }
const _hoisted_9 = {
  key: 2,
  class: "successful-subscription"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import { ref, onBeforeMount, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import IconButton from "../IconButton.vue";
import RoundedButton from "../RoundedButton.vue";
import { SUBSCRIPTION_MODELS } from "../../assets/constants";
import SubscriptionOverviewCard from "./SubscriptionOverviewCard.vue";
import { loadStripe, PaymentIntentResult } from "@stripe/stripe-js";
import { StripeElements, StripeElement } from "vue-stripe-js";
import { getCurrentUserSubscriptionDetails } from "../../assets/helpers_legacy";
interface Props {
  visible: boolean;
  setVisible: Function;
  formattedSelectedSubscriptionPrice: string;
  selectedSubscriptionType:
    | typeof SUBSCRIPTION_MODELS.MONTHLY.type
    | typeof SUBSCRIPTION_MODELS.YEARLY.type;
}
interface CardElementStatus {
  brand: string;
  complete: boolean;
  elementType: string;
  empty: boolean;
  error: {
    code: string;
    type: string;
    message: string;
  } | undefined;
  value: {
    postalCode: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaySubscriptionModal',
  props: {
    visible: { type: Boolean },
    setVisible: { type: Function },
    formattedSelectedSubscriptionPrice: {},
    selectedSubscriptionType: {}
  },
  emits: ["subscriptionSuccess"],
  setup(__props: any, { emit: __emit }) {

const LockGreyIcon = require("../../assets/images/Lock-grey.svg") as string;
const CheckmarkCircleGreyIcon =
  require("../../assets/images/Checkmark-circle-grey.svg") as string;
const CloseGreyIcon = require("../../assets/images/Close-grey.svg") as string;

const props = __props;

const loading = ref(true);
const successfulSubscription = ref(false);
const orderSubmitted = ref(false);
const orderSubmissionLoading = ref(false);
const orderSubmissionErrorMessage = ref("");
const currentUserSubscriptionDetails = ref();
const stripe = ref();
const card = ref();
const elms = ref();
const instanceOptions = ref({
  // https://stripe.com/docs/js/initializing#init_stripe_js-options
});
const elementsOptions = ref({
  // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
});

const cardElementStatus = ref<CardElementStatus|undefined>(undefined);
const cardElementErrorMessage = ref("");


const emit = __emit;

const store = useStore();

const stripeKey = computed<string>(() => {
  switch (store.state.user.currentUser.location) {
    case "CA":
      return process.env.VUE_APP_STRIPE_PK_CA || "";
    case "GB":
      return process.env.VUE_APP_STRIPE_PK_GB || "";
    case "US":
      return process.env.VUE_APP_STRIPE_PK_US || "";
    default:
      return process.env.VUE_APP_STRIPE_PK_US || "";
  }
});

onBeforeMount(async () => {
  stripe.value = await loadStripe(stripeKey.value);

  currentUserSubscriptionDetails.value =
    await getCurrentUserSubscriptionDetails();
  loading.value = false;
});

function cardElementOnChange(event: CardElementStatus) {
  cardElementStatus.value = event;
  cardElementErrorMessage.value = "";
}



function submitOrder() {
  if (
    !currentUserSubscriptionDetails.value.isFreeTrialEligible &&
    store.state.user.currentUser.type !== "Org User" &&
    cardElementStatus.value === undefined ||
    cardElementStatus.value && (
      cardElementStatus.value.error || 
      cardElementStatus.value.empty || 
      !cardElementStatus.value.complete
    )
  ) {
    console.log("Stripe card validator failed", cardElementStatus.value?.error)
    if (cardElementStatus.value === undefined) {
      cardElementErrorMessage.value = 'The card info is empty - please fill out the form';
    } else {
      cardElementErrorMessage.value = cardElementStatus.value.error &&
        cardElementStatus.value.error.message ||
        'There was an error with the card info - please check again';
    }

    return
  }

  orderSubmitted.value = true;
  orderSubmissionLoading.value = true;
  orderSubmissionErrorMessage.value = "";

  const data = {
    interval: props.selectedSubscriptionType,
  };

  axios
    .post(process.env.VUE_APP_MP_SERVER_API_URL + "self/subscription", data, {
      withCredentials: false,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(localStorage.getItem("tokenMP") || "").accessToken,
      },
    })
    .then((response) => {
      if (response.data.status === "error") {
        if (response.data.message) {
          orderSubmissionErrorMessage.value = response.data.message;
        } else {
          orderSubmissionErrorMessage.value =
            "There was an error processing your subscription";
        }

        console.log("Error: ", response);
      } else if (response.data.status === "success") {
        if (response.data.data.subscription.status === "trialing") {
          // Auto-enrolled for free month trial
          onSuccessfulSubscription();
          return;
        } else {
          // Not eligible for free month trial, pay now
          elms.value.instance
            .confirmCardPayment(
              response.data.data.paymentIntent.client_secret,
              {
                payment_method: {
                  card: card.value.stripeElement,
                },
              }
            )
            .then((result: PaymentIntentResult) => {
              if (result.error) {
                if (result.error.message) {
                  orderSubmissionErrorMessage.value = result.error.message;
                } else {
                  orderSubmissionErrorMessage.value = "";
                }
                return;
              } else {
                // Successful subscription
                onSuccessfulSubscription();
              }
            });
        }
      }
      orderSubmissionLoading.value = false;
    })
    .catch((e) => {
      console.error("error while creating subscription:", e);
      orderSubmissionErrorMessage.value =
        "There was an error processing your subscription";
      orderSubmissionLoading.value = false;
    });
}

function onSuccessfulSubscription() {
  successfulSubscription.value = true;

  setTimeout(() => {
    emit("subscriptionSuccess");
  }, 3000);
}

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return _withDirectives((_openBlock(), _createBlock(_component_Dialog, {
    visible: props.visible,
    modal: "",
    class: "pay-subscription-modal",
    closable: false,
    "aria-label": "Pay Subscription Modal",
    "aria-labelledby": loading.value || !successfulSubscription.value ? 'pay-subscription-modal-header' : 'successful-subscription-header'
  }, {
    header: _withCtx(() => [
      _createVNode(IconButton, {
        icon: _unref(CloseGreyIcon),
        class: "close-button",
        alt: "Close dialog",
        onclick: 
          () => {
            _ctx.setVisible(false);
          }
        ,
        enterPress: 
          () => {
            _ctx.setVisible(false);
          }
        ,
        ariaLabel: "Close modal",
        xsmall: ""
      }, null, 8, ["icon", "onclick", "enterPress"]),
      (loading.value || !successfulSubscription.value)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Payment details"))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                "aria-role": "presentation",
                alt: "Checkmark",
                src: _unref(CheckmarkCircleGreyIcon)
              }, null, 8, _hoisted_4)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Congratulations!", -1))
          ]))
    ]),
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_ProgressSpinner, { class: "spinner bottom" })
          ]))
        : (!successfulSubscription.value)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              class: "payment-details-body",
              onSubmit: _withModifiers(submitOrder, ["prevent"])
            }, [
              (!currentUserSubscriptionDetails.value.isFreeTrialEligible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", { for: "stripeInput" }, "Card information", -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["stripe-input-wrapper payment-input", cardElementErrorMessage.value ? 'payment-input-error' : '']),
                      id: "stripeInput"
                    }, [
                      (stripe.value)
                        ? (_openBlock(), _createBlock(_unref(StripeElements), {
                            key: 0,
                            ref_key: "elms",
                            ref: elms,
                            "stripe-key": stripeKey.value,
                            "instance-options": instanceOptions.value,
                            "elements-options": elementsOptions.value
                          }, {
                            default: _withCtx(({ elements }) => [
                              _createVNode(_unref(StripeElement), {
                                ref_key: "card",
                                ref: card,
                                elements: elements,
                                onChange: cardElementOnChange
                              }, null, 8, ["elements"])
                            ]),
                            _: 1
                          }, 8, ["stripe-key", "instance-options", "elements-options"]))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(cardElementErrorMessage.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(SubscriptionOverviewCard, {
                subscriptionModel: _ctx.selectedSubscriptionType,
                formattedSubscriptionPrice: _ctx.formattedSelectedSubscriptionPrice,
                class: "subscription-overview-card",
                freeTrialEligible: currentUserSubscriptionDetails.value.isFreeTrialEligible
              }, null, 8, ["subscriptionModel", "formattedSubscriptionPrice", "freeTrialEligible"]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(orderSubmissionErrorMessage.value), 1),
              _createVNode(RoundedButton, {
                text: 
          currentUserSubscriptionDetails.value.isFreeTrialEligible
            ? 'Start free trial'
            : 'Pay ' + _ctx.formattedSelectedSubscriptionPrice
        ,
                loading: orderSubmissionLoading.value,
                fitWidth: "",
                accent: "",
                lessRound: "",
                uppercase: "",
                class: "action-button payment-button",
                image: _unref(LockGreyIcon),
                type: "submit",
                rightIcon: "",
                ariaLabel: currentUserSubscriptionDetails.value.isFreeTrialEligible
            ? 'Start free trial'
            : 'Pay ' + _ctx.formattedSelectedSubscriptionPrice
            
              }, null, 8, ["text", "loading", "image", "ariaLabel"])
            ], 32))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (currentUserSubscriptionDetails.value.isFreeTrialEligible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[3] || (_cache[3] = [
                    _createElementVNode("p", null, _toDisplayString("You have successfully subscribed to our Free Trial.\nYou will receive an email confirmation shortly."), -1),
                    _createElementVNode("p", null, " Enjoy one month of unlimited recordings stored securely on our cloud, AI transcripts, pay-per-order notes for audio recordings and uploads, and study assistant. ", -1),
                    _createElementVNode("p", null, "Make the most of your trial period!", -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[4] || (_cache[4] = [
                    _createElementVNode("p", null, _toDisplayString("You have successfully subscribed to our plan.\nYou will receive an email confirmation shortly."), -1),
                    _createElementVNode("p", null, " Thank you for choosing our service, and we hope you have a great experience! ", -1)
                  ]))),
              _createVNode(RoundedButton, {
                text: "OK",
                accent: "",
                tall: "",
                wide: "",
                lessRound: "",
                uppercase: "",
                class: "action-button",
                autofocus: "",
                ariaLabel: 'OK',
                "enter-press": () => props.setVisible(false),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (props.setVisible(false)))
              }, null, 8, ["enter-press"])
            ]))
    ]),
    _: 1
  }, 8, ["visible", "aria-labelledby"])), [
    [_directive_focustrap]
  ])
}
}

})